import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { HomePage } from '@/pages/HomePage';
import { RangePage } from '@/pages/RangePage';
import { ProductDetailPage } from '@/pages/ProductDetailPage';
import { AboutPage } from '@/pages/AboutPage';
import { InnovationPage } from '@/pages/InnovationPage';
import { CsrPage } from '@/pages/CsrPage';
import { ContactPage } from '@/pages/ContactPage';
import { LegalPage } from '@/pages/LegalPage';
import { AuthLayout, RequireAuth, RequireAuthBare, RedirectIfAuthed } from '@/portal/guards';
import { LoginPage } from '@/portal/pages/LoginPage';
import { AcceptInvitePage } from '@/portal/pages/AcceptInvitePage';
import { ChangePasswordPage } from '@/portal/pages/ChangePasswordPage';
import { PortfoliosPage } from '@/portal/pages/PortfoliosPage';
import { CollectionPage } from '@/portal/pages/CollectionPage';
import { PortfolioEditorPage } from '@/portal/pages/PortfolioEditorPage';
import { SharedPage } from '@/portal/pages/SharedPage';

/** Public marketing site — wrapped in the header/footer chrome. */
function MarketingLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Customer portal — its own full-screen chrome, no marketing header/footer */}
        <Route element={<AuthLayout />}>
          <Route element={<RedirectIfAuthed />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/invite/:token" element={<AcceptInvitePage />} />
          </Route>
          <Route element={<RequireAuthBare />}>
            <Route path="/portal/change-password" element={<ChangePasswordPage />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route path="/portal" element={<PortfoliosPage scope="mine" />} />
            <Route path="/portal/collection" element={<CollectionPage />} />
            <Route path="/portal/shared" element={<PortfoliosPage scope="shared" />} />
            <Route path="/portal/portfolio/:id" element={<PortfolioEditorPage />} />
          </Route>
        </Route>

        {/* Public, read-only shared lookbook (no login) */}
        <Route path="/shared/:token" element={<SharedPage />} />

        {/* Public marketing site */}
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/order/:slug" element={<RangePage kind="order" />} />
          <Route path="/portfolio/:slug" element={<RangePage kind="portfolio" />} />
          <Route path="/product/:code" element={<ProductDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/innovation" element={<InnovationPage />} />
          <Route path="/csr" element={<CsrPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
          <Route path="/cookie" element={<LegalPage pageKey="cookie" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
